module.exports = __webpack_public_path__ + "static/media/todoIconIncomplete.cade7acc.svg";